import { PersonRequest } from "@plinknz/tah-website-elements";
import { personalDetailsConfig } from "./config-generics/personal-details";
import { signatureConfig } from "./config-generics/signature";
import { PageConfig } from "../../components/content-blocks/forms/customer-form-types";
import { UserData } from "../reducers/user";
import { overviewConfig } from "./config-generics/overview";
import { bankConfig } from "./config-generics/bank-details";

export const createSurveyConfig = (member: PersonRequest, user?: UserData) => {
    const personalConfig = personalDetailsConfig({
        member,
        children: user.onSameEmail,
    });

    const overviewDetailsConfig = overviewConfig({
        heading: "Tahua Wānanga | Symposium Grant",
        content: [
            {
                heading: "Overview",
                lines: [
                    `Supports attendance at educational wānanga, symposiums,
                    forums, or seminars. It is for registered Ngāti Kuia whānau
                    who have not received a tertiary grant in the same year.`,
                ],
            },
            {
                heading: "Eligibility",
                lines: [
                    "To apply for this grant, you must:",
                    [
                        "Be a registered member of Ngāti Kuia",
                        "Provide proof of bank account (deposit form or electronic statement).",
                        "Provide proof of the educational wānanga, symposium, forum, or seminar.",
                    ],
                ],
            },
            {
                heading: "Key Dates & Deadlines",
                lines: [
                    [
                        "Deadline: six weeks before the event.",
                        "Payment: before the event.",
                    ],
                ],
            },
            {
                heading: "Funding Available",
                lines: ["Up to $250 per person per year."],
            },
            {
                heading: "Documents You'll Need",
                lines: [
                    [
                        "Bank account details (deposit form or electronic statement).",
                        "Proof of the educational event.",
                    ],
                ],
            },
        ],
    });

    const otherConfig: PageConfig[] = [
        {
            name: "circumstances",
            title: "Event - Kaupapa",
            questions: [
                {
                    name: "event",
                    title:
                        "Provide details of the educational wānanga, symposium, forum, or seminar.",
                    placeHolder: "Kaupapa",
                    type: "comment",
                    isRequired: true,
                },
                {
                    name: "benefit",
                    title: "How will this be of benefit to Ngāti Kuia?",
                    placeHolder: "Ngā hua",
                    type: "comment",
                    isRequired: true,
                },
                {
                    type: "file",
                    name: "attachments",
                    title:
                        "Please upload any supporting documentation relevant to your application (e.g. proof of event)",
                    storeDataAsText: false,
                    allowMultiple: true,
                    maxSize: 10485760,
                    waitForUpload: true,
                    startWithNewLine: true,
                    isRequired: true,
                },
            ],
        },
    ];

    const pages: PageConfig[] = [
        ...overviewDetailsConfig,
        ...personalConfig,
        ...bankConfig,
        ...otherConfig,
        ...signatureConfig,
    ];

    return { pages };
};
